// extracted by mini-css-extract-plugin
export default {"flexContainer":"Step1_flexContainer__bS0bZ","uploadContainer":"Step1_uploadContainer__wKZhh","detailsContainer":"Step1_detailsContainer__sre1W"};